import IconClose from '../icons/close';
import { SelectSize } from '../select/types';
import { FilterTagTypes } from './types';

import './tags.css';

export default function FilterTag({
  title,
  type = 'default',
  onClick,
  value,
  size,
  className,
}: FilterTagTypes): React.JSX.Element {
  return (
    <div
      className={`filter-tag ${type === 'round' ? 'round' : ''} ${
        size === SelectSize.SMALL ? 'small' : ''
      } ${className || ''} ${!onClick ? 'without-padding' : ''}`}
    >
      <span>{title}</span>
      {value && <span>{value}</span>}
      {onClick && (
        <button
          type="button"
          onClick={onClick}
          aria-label="Close button"
          tabIndex={-1}
        >
          <IconClose className="icon-small" />
        </button>
      )}
    </div>
  );
}
